import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DocumentService} from '../../services/document.service';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import * as _ from 'lodash';
import {Document} from '../../models/document';
import {DocumentNotification} from '../../models/document-notification';
import {SelectItem} from '../../models/select-item';
import Swal from 'sweetalert2';
import {UtilsService} from '../../appSharedModule/services/utils.service';

@Component({
  selector: 'app-document-notification',
  templateUrl: './document-notification.component.html',
  styleUrls: ['./document-notification.component.scss']
})

export class DocumentNotificationComponent implements OnInit {

  document: Document;
  documentUniqid: string;
  isNewDocument: boolean;
  pageTitle: string;
  documentNotification: DocumentNotification;
  displayOneSectionUsers: boolean;
  displayTwoSectionUsers: boolean;
  bannersOptions: SelectItem[] = [];
  usersOptions: SelectItem[] = [];
  newUsersOptions: SelectItem[] = [];
  watchingUsersOptions: SelectItem[] = [];
  selectedUsers: number[] = [];
  selectedNewUsers: number[] = [];
  selectedUsersPrevDownloadedDoc: number[] = [];
  documentLink = '{{service_provider_document_link}}';
  previewDocumentLink: string;
  error: boolean;
  errorMessage: string;
  messagePreview: string;
  display: boolean;
  title: string;
  srcImg: string;
  footer: any;
  selectedCompanies: SelectItem[] = [];
  noSelectedUser = false;

  constructor(private _route: ActivatedRoute,
              private authenticationService: AuthenticationService,
              private documentService: DocumentService,
              private utilsService: UtilsService) {
  }

  ngOnInit() {
    this.error = false;
    this.errorMessage = '';
    this.documentService.displayNotificationNewButton = false;
    this.bannersOptions = [
      {label: 'Based on client affiliation', value: 'clientAffiliation'},
      {label: 'McKay only', value: 'mckay'},
      {label: 'Quincy only', value: 'quincy'}
    ];
    this._route.paramMap.subscribe(params => {
      const currentCompanyUniqId = params.get('currentCompanyUniqId');
      if (currentCompanyUniqId !== this.getUserCurrent().company.uniqid || this.getUserCurrent().company.uniqid !== 'admin') {
        this.redirectionToNotFound();
      }
      this.documentUniqid = params.get('documentUniqid');
      this.getDocumentByUniqid();
      this.documentNotification = new DocumentNotification();
      this.documentNotification.ccMckay = true;
      this.documentNotification.banner = 'clientAffiliation';
      this.documentNotification.users = [];

      this.getEmailFooter();
    });
  }

  getDefaultMessage(pattern: string) {
    this.documentNotification.message = 'Dear Customer,<br>'
      + pattern.charAt(0).toUpperCase() + pattern.slice(1).toLowerCase()
      + ' document is now available for download on our Portal: '
      + this.document.title + '<br>You may download it from here: '
      + this.documentLink + '.<br>Best regards<br>';
  }

  fillOptions(users, watchingDocument = false) {
    const options = [];
    _.forEach(users, (user: any) => {
      let i = options.findIndex(x => x.value.id === user.companyUniqid);
      if (i === -1) {
        options.push({
          label: user.companyName,
          value: {
            id: user.companyUniqid,
            childOptions: [],
            selectedChildOptions: []
          },
        });
        i = options.findIndex(x => x.value.id === user.companyUniqid);
        if (watchingDocument) {
          this.selectedCompanies.push(options[i]);
        }
      }
      const k = options[i].value.childOptions.findIndex(x => x.value === user.id);
      if (k === -1) {
        options[i].value.childOptions.push({
          label: user.userName + ' <' + user.userEmail + '>',
          value: user.id
        });
      }
    });
    options.forEach(option => option.value.childOptions.sort((a, b) => a.label.localeCompare(b.label)));
    return options.sort((a, b) => a.label.localeCompare(b.label));
  }

  fillSelectedUsersIds(event: any) {
    this.selectedUsers = [];
    this.noSelectedUser = false;
    this.prepareSelectedUsers(event, this.selectedUsers);
    this.fillSelectedUsers();
  }

  fillSelectedNewUsersIds(event: any) {
    this.selectedNewUsers = [];
    this.prepareSelectedUsers(event, this.selectedNewUsers);
    this.fillSelectedUsers();
  }

  fillSelectedUsersDownloadedDocIds(event: any) {
    this.selectedUsersPrevDownloadedDoc = [];
    this.prepareSelectedUsers(event, this.selectedUsersPrevDownloadedDoc);
    this.fillSelectedUsers();
  }

  getUserCurrent() {
    return this.authenticationService.getUserCurrent();
  }

  redirectionToHomePage() {
    this.documentService.successSendNotification = false;
    location.assign('/#/document/' + this.documentUniqid + '/show');
  }

  sendNotification() {
    if (this.utilsService.editorHtmlWithBreakableSpaces(this.documentNotification.message).length > 10000) {
      this.error = true;
      this.errorMessage = 'Make sure the email body is not longer than 10,000 characters.';
      return;
    }
    if (this.documentNotification.users.length === 0) {
      this.noSelectedUser = true;
      Swal.fire({
        text: 'Please select at least one user to send the notification.',
        confirmButtonColor: '#3085d6',
      });
      return;
    }
    this.noSelectedUser = false;
    if (this.documentNotification.users.length > 0 || this.documentNotification.ccMckay) {
      if (this.documentNotification.message === null || this.documentNotification.message === '') {
        if (this.isNewDocument) {
          this.getDefaultMessage('a new');
        } else {
          this.getDefaultMessage('an updated');
        }
      }
      if (this.documentNotification.subject === null || this.documentNotification.subject === '') {
        if (this.isNewDocument) {
          this.getDefaultSubject('New');
        } else {
          this.getDefaultSubject('Updated');
        }
      }
      this.documentService.sendNotificationToClients(this.documentUniqid, {
        ...this.documentNotification,
        message: this.utilsService.editorHtmlWithBreakableSpaces(this.documentNotification.message)
      }).subscribe({
          next: () => {
            this.documentService.successSendNotification = true;
            location.assign('/#/document/' + this.documentUniqid + '/show');
          }, error: error => {
            this.error = true;
            if (!error.error.message) {
              this.errorMessage = 'An error occurred.';
            } else {
              this.errorMessage = error.error.message;
            }
          }
        }
      );
    }

  }

  previewEmail() {
    if (this.documentNotification.banner === 'mckay') {
      this.srcImg = '../../../assets/images/logo-mckay.png';
    } else if (this.documentNotification.banner === 'quincy') {
      this.srcImg = '../../../assets/images/logo-quincy.png';
    }
    this.title = 'Subject: ' + this.documentNotification.subject;
    this.display = true;
    this.messagePreview = this.normalizeMustache(this.utilsService.editorHtmlWithBreakableSpaces(this.documentNotification.message)).replace(this.documentLink, this.previewDocumentLink);
  }

  normalizeMustache(text: string): string {
    return text.replace(/\{\{([\s\S]*?)\}\}/g, (_full, inner: string) => {
      const edgeWs = /^(?:\s|\u00A0|&nbsp;)+|(?:\s|\u00A0|&nbsp;)+$/g;
      const trimmed = inner.replace(edgeWs, '');
      return `{{${trimmed}}}`;
    });
  }

  getFooter() {
    if (!this.footer) {
      return '';
    }
    if (this.documentNotification.banner === 'quincy') {
      return this.footer['quincy'];
    }
    return this.footer['mckay'];
  }

  private getDocumentByUniqid() {
    this.documentService.getDocumentByUniqid(this.documentUniqid).subscribe({
        next: (document: any) => {
          this.document = document[0];
          this.setIsNewDocument(this.document.isNew);
          if (this.isNewDocument) {
            this.getDefaultTitle('a new');
            this.getDefaultSubject('New');
            this.getDefaultMessage('a new');
          } else {
            this.getDefaultTitle('an updated');
            this.getDefaultSubject('Updated');
            this.getDefaultMessage('an updated');
          }
          this.getUsersNotificationDocument();
        },
        error: () => {
          this.redirectionToNotFound();
        }
      }
    );
  }

  private getEmailFooter() {
    this.documentService.getEmailFooter().subscribe(
      res => {
        this.footer = res;
      }
    );
  }

  private getDefaultTitle(pattern: string) {
    this.pageTitle = 'Notify users of ' + pattern + ' document';
  }

  private getDefaultSubject(subject: string) {
    this.documentNotification.subject = subject + ' document available on Portal: ' + this.document.title;
  }

  private getUsersNotificationDocument() {

    this.documentService.getUsersNotificationDocument(this.documentUniqid).subscribe(
      result => {
        this.previewDocumentLink = result['documentLink'];
        if (result['users']) {
          this.displayOneSectionUsers = true;
          this.usersOptions = [];
          this.usersOptions = this.fillOptions(result['users']);
        } else {
          this.displayTwoSectionUsers = true;
          if (result['newUsers']) {
            this.newUsersOptions = [];
            this.newUsersOptions = this.fillOptions(result['newUsers']);
          }
          if (result['watchingUsers']) {
            this.watchingUsersOptions = [];
            this.watchingUsersOptions = this.fillOptions(result['watchingUsers'], true);
          }
        }
      }, error => {
        this.error = true;
        if (!error.error.message) {
          this.errorMessage = 'An error occurred.';
        } else {
          this.errorMessage = error.error.message;
        }
      });
  }

  private prepareSelectedUsers(event: any, list: number[]) {
    event.parentOptions.forEach((userId) => {
      userId.value.selectedChildOptions.forEach((child) => {
        list.push(child);
      });
    });
    event.childOptions.forEach((userId) => {
      list.push(userId);
    });
  }

  private fillSelectedUsers() {
    this.documentNotification.users = [];
    if (this.selectedUsers.length > 0) {
      this.documentNotification.users = this.selectedUsers;
    } else {
      this.documentNotification.users = this.selectedNewUsers.concat(this.selectedUsersPrevDownloadedDoc);
    }
  }

  private redirectionToNotFound() {
    this.utilsService.redirectToNotFound();
  }

  private setIsNewDocument(isNew) {
    const now = new Date().getTime();
    const isDocumentOverdue = ((now - new Date(this.document.availableSince).getTime()) / 3600000) > 24;
    this.isNewDocument = isNew && !isDocumentOverdue;
  }
}
